import { Import, Mail, Share, User, UserPlus } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React, { useCallback, useMemo, useState } from "react";
import { XStack, YStack } from "tamagui";
import {
  FormDataModal,
  FormSheetType,
} from "../../../../core/components/FormDataModal";
import { BodyTextarea } from "../../../../ui/Body";
import { Box } from "../../../../ui/Box";
import { Button } from "../../../../ui/Button";
import { Label } from "../../../../ui/Label";
import type { BusinessPlanModel } from "../../BusinessPlanModel";
import { BusinessAdminPlanUsersUI } from "../../ui/BusinessPlanAdminUsersUI";
import { BusinessPlanImportUsersModal } from "./BusinessPlanImportUsersModal";

type Props = {
  businessPlan: BusinessPlanModel;
};

enum UserAddType {
  Single = "single",
  Import = "import",
}

export const BusinessSettingsUsers: React.FC<Props> = observer((props) => {
  const [showUserForm, setShowUserForm] = useState<UserAddType | null>(null);

  const addUser = useCallback(
    (userProps: { email: string; displayName: string }) => {
      props.businessPlan.addUser({
        ...userProps,
        authedUsers: [],
        avatarUrl: "",
      });
    },
    [props.businessPlan],
  );

  return (
    <YStack gap={"$medium"}>
      <Box>
        <XStack gap={"$medium"} alignItems={"center"}>
          <Share />
          <Label>Share url</Label>
        </XStack>
        <BodyTextarea
          readOnly={true}
          value={`https://planira.app/welcome/${props.businessPlan.uid}`}
          type="border"
          multiline={false}
        />
      </Box>
      <Button
        icon={UserPlus}
        onPress={() => setShowUserForm(UserAddType.Single)}
      >
        Add member
      </Button>
      <Button icon={Import} onPress={() => setShowUserForm(UserAddType.Import)}>
        Import members
      </Button>

      <BusinessAdminPlanUsersUI businessPlanUid={props.businessPlan.uid} />

      <BusinessPlanImportUsersModal
        businessPlanUid={props.businessPlan.uid}
        onClose={() => setShowUserForm(null)}
        visible={showUserForm === UserAddType.Import}
      />

      <FormDataModal
        visible={showUserForm === UserAddType.Single}
        onClose={() => {
          setShowUserForm(null);
        }}
        title="Add new user"
        values={useMemo(
          () => ({
            displayName: "",
            email: "",
          }),
          [],
        )}
        form={[
          {
            formKey: "displayName",
            label: "Name",
            type: FormSheetType.Input,
            icon: User,
            placeholder: "Name",
            required: true,
          },
          {
            formKey: "email",
            label: "Email",
            type: FormSheetType.Email,
            icon: Mail,
            placeholder: "Email",
            required: true,
          },
        ]}
        onSave={(data) => {
          addUser({ email: data.email, displayName: data.displayName });
        }}
      />
    </YStack>
  );
});
